"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var UserAction;
(function (UserAction) {
    UserAction.SET_USER = 'SET_USER';
    UserAction.SET_USER_DONE = 'SET_USER_DONE';
    UserAction.setUser = typesafe_actions_1.createAction(UserAction.SET_USER, function (resolve) { return function (user) { return resolve(user); }; });
    UserAction.setUserDone = typesafe_actions_1.createAction(UserAction.SET_USER_DONE, function (resolve) { return function (user) { return resolve(user); }; });
})(UserAction || (UserAction = {}));
exports.default = UserAction;
